import { getTeamBillingStatus, createTeamCheckout, createTeamBillingPortal } from './api';

export function stripeDestination(raw, kind) {
  const url = new URL(raw);
  const expected = kind === 'portal' ? 'billing.stripe.com' : 'checkout.stripe.com';
  if (url.protocol !== 'https:' || url.hostname !== expected || url.username || url.password) {
    throw new Error('Ogiltig betalningsadress. Försök igen.');
  }
  return url.href;
}

// Read the exact team's server status before choosing an operation. A pending
// payment on an existing subscription must not create a second subscription.
export async function teamBillingAction(teamId, isCurrent = () => true, promotionCode) {
  if (!teamId || !isCurrent()) return null;
  const { data } = await getTeamBillingStatus(teamId);
  if (!isCurrent()) return null;
  if (data.team_id !== teamId) throw new Error('Lagets betalningsstatus kunde inte bekräftas.');
  if (data.has_access) return { kind: 'active' };
  const entitlement = data.entitlement || {};
  const ended = ['canceled', 'cancelled', 'incomplete_expired'].includes(entitlement.status);
  const portal = Boolean(entitlement.stripe_subscription_id) && !ended;
  const result = portal
    ? await createTeamBillingPortal(teamId, `${window.location.origin}/billing/success?team_id=${encodeURIComponent(teamId)}`)
    : await createTeamCheckout(teamId, window.location.origin, promotionCode);
  if (!isCurrent()) return null;
  const kind = portal ? 'portal' : 'checkout';
  return { kind, url: stripeDestination(portal ? result.data.portal_url : result.data.checkout_url, kind) };
}
